import React from 'react';

/**
 * The day the open amount is due, picked per invoice — as the client-side
 * invoice dialog offered (#3427). Empty means the tenant's Zahlungsziel, which
 * the server applies; the field holds a plain `YYYY-MM-DD` day and never
 * converts it, so no clock can move it.
 */
const InvoiceDueDateField = ({
    id, label, hint, value, disabled = false, onChange,
}: Readonly<{
    id: string;
    label: string;
    hint: string;
    value: string;
    disabled?: boolean;
    onChange: (value: string) => void;
}>) => (
    <div className={'mb-3'}>
        <label className={'block text-sm text-foreground/60 mb-1'} htmlFor={id}>
            {label}
        </label>
        <input
            id={id}
            type={'date'}
            value={value}
            disabled={disabled}
            onChange={(e) => onChange(e.target.value)}
            className={'border border-foreground/20 rounded-[5px] px-3 py-2 text-sm mb-1'}
        />
        <p className={'text-xs text-foreground/60'}>{hint}</p>
    </div>
);

export default InvoiceDueDateField;
